import { Settings, User, Shield, Key, Pin, File, Users, FileText, BarChart3 } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { PERMISSIONS } from "./permissions";

export interface MenuItem {
  name: string;
  icon?: LucideIcon;
  path?: string;
  requiredPermission?: string;
  requiredPermissions?: string[];
  subitems?: MenuItem[];
}

export interface MenuSection {
  name: string;
  icon: LucideIcon;
  requiredRole?: string;
  requiredRoles?: string[];
  requiredPermissions?: string[];
  subitems?: MenuItem[];
}

/** Um item (ou subitem) é visível se o usuário satisfaz `requiredPermission`
 *  (única) ou qualquer uma de `requiredPermissions` (lista). */
export const isItemVisible = (item: MenuItem, permissions: string[]): boolean => {
  if (item.requiredPermission && !permissions.includes(item.requiredPermission)) return false;
  if (item.requiredPermissions?.length && !item.requiredPermissions.some((p) => permissions.includes(p))) return false;
  return true;
};

export const MENU_SECTIONS: MenuSection[] = [
  //  {
  //    name: "Hub de Processos",
  //    icon: FileText,
  //    subitems: [
  //      {
  //        name: "Formulários",
  //        icon: FileText,
  //        path: "/internal/process-hub/forms",
  //      },
  //    ],
  //  },
  {
    name: "Admin",
    icon: Settings,
    requiredRole: "admin",
    requiredPermissions: [
      PERMISSIONS.ADMIN.MANAGE_USERS,
      PERMISSIONS.ADMIN.MANAGE_ROLES,
      PERMISSIONS.ADMIN.MANAGE_PERMISSIONS,
      PERMISSIONS.ADMIN.MANAGE_LEADERS,
    ],
    subitems: [
      {
        name: "Usuários",
        icon: User,
        path: "/internal/admin/users",
        requiredPermission: PERMISSIONS.ADMIN.MANAGE_USERS,
      },
      {
        name: "Papéis",
        icon: Shield,
        path: "/internal/admin/roles",
        requiredPermission: PERMISSIONS.ADMIN.MANAGE_ROLES,
      },
      {
        name: "Permissões",
        icon: Key,
        path: "/internal/admin/permissions",
        requiredPermission: PERMISSIONS.ADMIN.MANAGE_PERMISSIONS,
      },
      {
        name: "Gestores",
        icon: Users,
        path: "/internal/admin/leaders",
        requiredPermission: PERMISSIONS.ADMIN.MANAGE_PERMISSIONS,
      },
    ],
  },
  {
    name: "Trilha Admissional",
    icon: User,
    requiredPermissions: [
      PERMISSIONS.RH.CANDIDATES_MANAGEMENT,
      PERMISSIONS.RH.WHITELIST_MANAGE,
      PERMISSIONS.CYBER.CANDIDATES_PDF,
      PERMISSIONS.RH.ONBOARDING_MAP,
      PERMISSIONS.RH.PROCESSES_VIEW,
    ],
    subitems: [
      {
        name: "Gestão Candidatos",
        icon: File,
        requiredPermissions: [
          PERMISSIONS.RH.CANDIDATES_MANAGEMENT,
          PERMISSIONS.RH.PROCESSES_VIEW,
        ],
        subitems: [
          {
            name: "Mapa Candidatos",
            icon: File,
            path: "/internal/candidates/monitoring",
            requiredPermission: PERMISSIONS.RH.CANDIDATES_MANAGEMENT,
          },
          {
            name: "Processos Internos RH",
            icon: FileText,
            path: "/internal/rh/processes",
            requiredPermission: PERMISSIONS.RH.PROCESSES_VIEW,
          },
        ],
      },
      {
        name: "Credenciais de Acesso",
        icon: Shield,
        path: "/internal/cyber/access",
        requiredPermission: PERMISSIONS.CYBER.CANDIDATES_PDF,
      },
      {
        name: "Etapas Mapa",
        icon: Pin,
        path: "/internal/admissional/map",
        requiredPermission: PERMISSIONS.RH.ONBOARDING_MAP,
      },
    ],
  },
  {
    name: "Métricas",
    icon: BarChart3,
    requiredPermissions: [PERMISSIONS.RH.METRICS_VIEW],
    subitems: [
      {
        name: "Dashboard",
        icon: BarChart3,
        path: "/internal/metrics",
        requiredPermission: PERMISSIONS.RH.METRICS_VIEW,
      },
    ],
  },
];
